// Google Analytics 4 (gtag.js) integration.
//
// Standalone GA4 — independent of Firebase. The measurement ID is public by
// design (it ships in the client bundle), so a hardcoded fallback is fine;
// override it per environment with REACT_APP_GA4_MEASUREMENT_ID if needed.
//
// We disable gtag's automatic page_view (`send_page_view: false`) and send
// page_view events ourselves on every React Router navigation — otherwise an
// SPA only ever reports the initial load.

const GA_MEASUREMENT_ID =
  process.env.REACT_APP_GA4_MEASUREMENT_ID || "G-RRJ0W7H20F";

let initialized = false;

export function initGA4() {
  if (initialized) return;
  if (typeof window === "undefined" || !GA_MEASUREMENT_ID) return;

  // Inject the gtag.js loader.
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;

  gtag("js", new Date());
  gtag("config", GA_MEASUREMENT_ID, { send_page_view: false });

  initialized = true;
}

// Fire a page_view for an SPA route change.
export function trackPageView(path) {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  window.gtag("event", "page_view", {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
}

// Log a custom GA4 event, e.g. trackEvent("begin_checkout", { value: 50, currency: "MYR" }).
export function trackEvent(name, params = {}) {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  window.gtag("event", name, params);
}
